module.exports = __webpack_public_path__ + "static/media/torch.d6271b79.svg";